import { render, staticRenderFns } from "./wxhuizong1.vue?vue&type=template&id=28cad19f"
import script from "./wxhuizong1.vue?vue&type=script&lang=js"
export * from "./wxhuizong1.vue?vue&type=script&lang=js"
import style0 from "./wxhuizong1.vue?vue&type=style&index=0&id=28cad19f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports